module.exports = __webpack_public_path__ + "media/images/logo-evs-224250cae82956da1eb1e9e5b7473c5f.svg";